/**
 * @module categories ui
 */
import { createReducer } from '@reduxjs/toolkit';
import { surveyTypeActions } from '~/behaviors/actions/survey_type.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';

const defaultState = {
  isLoadingCategories: false,
};

const reset = () => defaultState;

const merge = (updates) => (state) => ({
  ...state,
  ...updates,
});

const surveyTypesUI = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(surveyTypeActions.fetchSurveyTypesWithCategories.pending, merge({ isLoadingCategories: true }));
  builder.addCase(surveyTypeActions.fetchSurveyTypesWithCategories.fulfilled, merge({ isLoadingCategories: false }));
  builder.addCase(surveyTypeActions.fetchSurveyTypesWithCategories.rejected, merge({ isLoadingCategories: false }));
});

export default surveyTypesUI;
